import { gql } from '@apollo/client';

export const CREATE_SITE_MUTATOR = gql`
  mutation createSiteMutator(
    $group_id: String
    $company_id: String
    $site_name: String
    $subdivision: JSON
    $region: JSON
    $latitude: String
    $longitude: String
    $glo_id: String
    $user_email: String
  ) {
    createSite(
      group_id: $group_id
      company_id: $company_id
      site_name: $site_name
      subdivision: $subdivision
      region: $region
      latitude: $latitude
      longitude: $longitude
      glo_id: $glo_id
      user_email: $user_email
    )
  }
`;

export const UPDATE_SITE_MUTATOR = gql`
  mutation updateSiteMutator(
    $group_id: String
    $company_id: String
    $updated_site: JSON
    $original_data: JSON
    $user_email: String
  ) {
    updateSite(
      group_id: $group_id
      company_id: $company_id
      updated_site: $updated_site
      original_data: $original_data
      user_email: $user_email
    )
  }
`;

export const DELETE_SITE_MUTATOR = gql`
  mutation deleteSiteMutator(
    $group_id: String
    $company_id: String
    $site_id: String
    $site_name: String
    $user_email: String
  ) {
    deleteSite(
      group_id: $group_id
      company_id: $company_id
      site_id: $site_id
      site_name: $site_name
      user_email: $user_email
    )
  }
`;

export const ARCHIVE_SITE_MUTATOR = gql`
  mutation archiveSiteMutator(
    $group_id: String
    $company_id: String
    $site_id: String
    $user_email: String
  ) {
    archiveSite(
      group_id: $group_id
      company_id: $company_id
      site_id: $site_id
      user_email: $user_email
    )
  }
`;

export const UNARCHIVE_SITE_MUTATOR = gql`
  mutation unarchiveSiteMutator(
    $group_id: String
    $company_id: String
    $site_id: String
    $user_email: String
  ) {
    unarchiveSite(
      group_id: $group_id
      company_id: $company_id
      site_id: $site_id
      user_email: $user_email
    )
  }
`;

export const DELETE_IMPORTED_SITES_BY_TRACKING_ID = gql`
  mutation deleteImportedSitesByTrackingId(
    $group_id: String
    $company_id: String
    $tracking_id: String
    $user_email: String
  ) {
    deleteImportedSitesByTrackingId(
      group_id: $group_id
      company_id: $company_id
      tracking_id: $tracking_id
      user_email: $user_email
    )
  }
`;
